import React from 'react';
import { useValueChange } from '@leverege/ui-hooks';
import { Pane, Flex, Label, TextInput, Checkbox } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Model from "./DataViewerCardModel.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.dashboard.DataViewerCardMenu');
export default function DataViewerCardMenu(props) {
  const {
    subMenu,
    value
  } = props;
  const onModelChange = useValueChange(Model, props);
  const needsDate = Model.getNeedsDate(value);
  const needsCondition = Model.getNeedsCondition(value);
  const needsOrder = Model.getNeedsOrder(value);
  let needsDateEditor = null;
  let needsConditionEditor = null;
  let needsOrderEditor = null;
  if (needsDate != null) {
    needsDateEditor = /*#__PURE__*/_jsx(Flex, {
      variant: "colM",
      align: "stretch",
      children: /*#__PURE__*/_jsx(Flex, {
        variant: "rowM",
        align: "center",
        justify: "space-between",
        children: /*#__PURE__*/_jsx(Checkbox, {
          label: t('useParentTimeRange'),
          eventData: "setNeedsDate",
          onChange: onModelChange,
          value: needsDate
        })
      })
    });
  }
  if (needsCondition != null) {
    needsConditionEditor = /*#__PURE__*/_jsx(Flex, {
      variant: "colM",
      align: "stretch",
      children: /*#__PURE__*/_jsx(Flex, {
        variant: "rowM",
        align: "center",
        justify: "space-between",
        children: /*#__PURE__*/_jsx(Checkbox, {
          label: t('useParentCondition'),
          eventData: "setNeedsCondition",
          onChange: onModelChange,
          value: needsCondition
        })
      })
    });
  }
  if (needsOrder != null) {
    needsOrderEditor = /*#__PURE__*/_jsx(Flex, {
      variant: "colM",
      align: "stretch",
      children: /*#__PURE__*/_jsx(Flex, {
        variant: "rowM",
        align: "center",
        justify: "space-between",
        children: /*#__PURE__*/_jsx(Checkbox, {
          label: t('useParentOrder'),
          eventData: "setNeedsOrder",
          onChange: onModelChange,
          value: needsOrder
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "padding",
    children: [/*#__PURE__*/_jsx(Flex, {
      variant: "colM",
      align: "stretch",
      children: /*#__PURE__*/_jsxs(Flex, {
        variant: "rowM",
        align: "center",
        justify: "space-between",
        children: [/*#__PURE__*/_jsx(Label, {
          variant: "dashboardCardEditor|small",
          children: t('height')
        }), /*#__PURE__*/_jsx(TextInput, {
          variant: "dashboardCardEditor|small",
          value: value.height,
          eventData: "setHeight",
          onChange: onModelChange
        })]
      })
    }), needsDateEditor, needsConditionEditor, needsOrderEditor, subMenu]
  });
}